"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaItemGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
const metaItemGroupGapTokens = {
    '2': { gap: shared_styles_1.spaces['2'] },
    '3': { gap: shared_styles_1.spaces['3'] },
    '8': { gap: shared_styles_1.spaces['8'] },
};
let MetaItemGroup = class MetaItemGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.direction = 'row';
        this.gap = '4';
        this.wrap = 'nowrap';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'group');
    }
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
MetaItemGroup.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      gap: ${(0, lit_1.unsafeCSS)(shared_styles_1.spaces['4'])};
    }

    :host([direction='column']) {
      flex-direction: column;
    }

    :host([wrap='wrap']) {
      flex-wrap: wrap;
    }
    :host([wrap='wrap-reverse']) {
      flex-wrap: wrap-reverse;
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('gap', metaItemGroupGapTokens))}
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], MetaItemGroup.prototype, "direction", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], MetaItemGroup.prototype, "gap", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], MetaItemGroup.prototype, "wrap", void 0);
MetaItemGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-meta-item-group')
], MetaItemGroup);
exports.MetaItemGroup = MetaItemGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0YS1pdGVtLWdyb3VwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibWV0YS1pdGVtLWdyb3VwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzRDtBQUN0RCxxREFBMkQ7QUFFM0QsK0RBQW1HO0FBQ25HLG1DQUFtRTtBQUtuRSxNQUFNLHNCQUFzQixHQUFvRDtJQUM5RSxHQUFHLEVBQUUsRUFBRSxHQUFHLEVBQUUsc0JBQU0sQ0FBQyxHQUFHLENBQUMsRUFBRTtJQUN6QixHQUFHLEVBQUUsRUFBRSxHQUFHLEVBQUUsc0JBQU0sQ0FBQyxHQUFHLENBQUMsRUFBRTtJQUN6QixHQUFHLEVBQUUsRUFBRSxHQUFHLEVBQUUsc0JBQU0sQ0FBQyxHQUFHLENBQUMsRUFBRTtDQUMxQixDQUFBO0FBR00sSUFBTSxhQUFhLEdBQW5CLE1BQU0sYUFBYyxTQUFRLGdCQUFVO0lBQXRDOztRQXNCc0MsY0FBUyxHQUFrQixLQUFLLENBQUE7UUFDaEMsUUFBRyxHQUFxQixHQUFHLENBQUE7UUFDM0IsU0FBSSxHQUFhLFFBQVEsQ0FBQTtJQVl0RSxDQUFDO0lBVkMsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsT0FBTyxDQUFDLENBQUE7SUFDcEMsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztLQUVWLENBQUE7SUFDSCxDQUFDOztBQWxDTSxvQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7OzthQUtSLElBQUEsZUFBUyxFQUFDLHNCQUFNLENBQUMsR0FBRyxDQUFDLENBQUM7Ozs7Ozs7Ozs7Ozs7O01BYzdCLElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsS0FBSyxFQUFFLHNCQUFzQixDQUFDLENBQUM7R0FDaEUsQ0FBQTtBQUMwQztJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQztnREFBaUM7QUFDaEM7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7MENBQTRCO0FBQzNCO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzJDQUEwQjtBQXhCekQsYUFBYTtJQUR6QixJQUFBLDZCQUFhLEVBQUMsb0JBQW9CLENBQUM7R0FDdkIsYUFBYSxDQW9DekI7QUFwQ1ksc0NBQWEifQ==